import { useEffect } from 'react';
import logger from '../utils/logger';

export default function useKeyboardNavigation(onNext: () => void, onBack?: () => void) {
  useEffect(() => {
    logger.debug('useKeyboardNavigation', 'Hook initialized', { hasOnNext: !!onNext, hasOnBack: !!onBack });
    
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        logger.userAction('useKeyboardNavigation', 'Enter key pressed, triggering onNext');
        e.preventDefault();
        onNext();
      } else if (e.key === 'Escape' && onBack) {
        logger.userAction('useKeyboardNavigation', 'Escape key pressed, triggering onBack');
        e.preventDefault();
        onBack();
      }
    };
    
    logger.debug('useKeyboardNavigation', 'Adding keyboard event listener');
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      logger.debug('useKeyboardNavigation', 'Removing keyboard event listener');
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [onNext, onBack]);
}
